module.exports = " <div> <div ng-include=\"'header-course'\"></div> <div ng-include=\"'courses-list'\"></div> <div ng-include=\"'course-details'\"></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/consolidationCP/teachingDevelopment/listTeacherJobsView/reviewTeacherDevelopment.html
// module id = 605
// module chunks = 0